/**
 * Created by staffanrantzow on 16/03/16.
 */

/* @flow */
import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import { InputField, SpinnerButton, GeneralError } from 'components';
import { Utils, UserService } from 'frilans-finans';
import { Link } from 'react-router';

export class SetNewPassword extends React.Component {

  static propTypes = {
    location: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      formValues: {
        password: {},
        repeatPassword: {}
      },
      passwordNotEqual: false,
      posting: false,
      postError: false,
      updated: false,
      showErrorWithoutBlur: false
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.callback = this.callback.bind(this);
  }

  callback (name, values) {
    var tempFormValues = this.state.formValues;

    Object.assign(tempFormValues[name], values);
    this.setState({formValues: tempFormValues}, () => {
      if (this.state.showErrorWithoutBlur) {
        this.validatePassword();
      }
    });
  }

  validatePassword () {
    let equal = this.state.formValues.password.value === this.state.formValues.repeatPassword.value;

    this.setState({
      passwordNotEqual: !equal
    });

    return equal;
  }

  postPassword () {
    UserService.changePassword(
      this.props.location.query.id,
      this.props.location.query.token,
      this.state.formValues.password.value)
      .then(this.handleSuccess.bind(this))
      .catch(this.handleError.bind(this));

    this.setState({
      posting: true,
      updated: false,
      postError: false
    });
  }

  handleSuccess (response) {
    this.setState({
      posting: false,
      updated: true,
      postError: false
    });

    UserService.fetchUser();
  }

  handleError () {
    this.setState({
      posting: false,
      updated: false,
      postError: true
    });
  }

  onSubmit (e) {
    e.preventDefault();

    this.setState({showErrorWithoutBlur: true}, () => {
      if (Utils.validateInputValues(this.state.formValues) && this.validatePassword()) {
        this.setState({
          loading: true
        }, this.postPassword);
      }
    });
  }

  renderError () {
    if (this.state.passwordNotEqual) {
      return (
        <p className='error show'><Translate content='PASSWORD_NOT_EQUAL'/></p>
      );
    }

    return false;
  }

  renderPostSuccess () {
    if (!this.state.posting && this.state.updated) {
      return (
        <div>
          <p className='info'><Translate content='PASSWORD_UPDATED' /></p>
          <Link to='login' className='btn'><Translate content='LOGIN' /></Link>
        </div>
      );
    }
  }

  renderForm () {
    var postError = this.state.postError ? (<GeneralError />) : false;

    return (
      <form onSubmit={this.onSubmit}>
        <div className='form-row'>
          <InputField type='password' name='password'
            placeholder={proxyCounterpart('PASSWORD')} callback={this.callback}
            required='true' minLength='12' validationType='passwordRegistration'
            errorMessage={proxyCounterpart('PASSWORD_ERROR_ORIGINAL')}
            showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
          <InputField type='password' name='repeatPassword'
            placeholder={proxyCounterpart('REPEAT_PASSWORD')} callback={this.callback}
            required='true' minLength='12' validationType='passwordRegistration'
            errorMessage={proxyCounterpart('PASSWORD_ERROR_REPEAT')}
            showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
        </div>

        {this.renderError()}

        {postError}

        <div className='button-wrapper'>
          <SpinnerButton text={proxyCounterpart('SEND')}
            loading={this.state.posting} classes='btn'/>
        </div>
      </form>
    );
  }

  renderContent () {
    if (!this.state.posting && this.state.updated && !this.state.postError) {
      return this.renderPostSuccess();
    }

    return this.renderForm();
  }

  render () {
    return (
      <div className="container set-new-password">
        <div className="row">
          <div className="col-sm-6 col-sm-push-3">
            <h2><Translate content='CREATE_PASSWORD'/></h2>
            <p>
              <Translate content='PASSWORD_ERROR'/>
            </p>
            {this.renderContent()}
          </div>
        </div>
      </div>
    );
  }

}

export default SetNewPassword;




/** WEBPACK FOOTER **
 ** ./src/views/forgot-password-view/set-new-password.js
 **/